import * as React from "react";

const Fb: React.FC = () => {
    return <svg width="8px" height="17px" viewBox="0 0 8 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Global-Elements/Footer-WF" transform="translate(-1042.000000, -195.000000)" fill="#9C5F16">
            <g transform="translate(1027.000000, 155.000000)">
                <g transform="translate(0.000000, 29.000000)">
                    <path d="M20.1896,16.4838933 L20.1896,14.7260267 C20.1896,14.0662933 20.6269333,13.91216 20.9346667,13.91216 L22.8258667,13.91216 L22.8258667,11.0102933 L20.2216,11.00016 C17.3298667,11.00016 16.6722667,13.1644267 16.6722667,14.5494933 L16.6722667,16.4838933 L15.0002667,16.4838933 L15.0002667,19.47376 L16.6722667,19.47376 L16.6722667,27.9356267 L20.1896,27.9356267 L20.1896,19.47376 L22.5624,19.47376 L22.8696,16.4838933 L20.1896,16.4838933 Z"></path>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(Fb);
